export default function Release2BHomeRecovery({ session, onResume }) {
  const record = session?.record;
  if (!record) return null;

  const baseRecovery = record.saved && ["Draft", "Needs Changes"].includes(record.status);
  const approvedMarketing = record.kind === "listing" && record.decisions?.budget === "Approved";
  const approvedOpenHouse = record.kind === "listing" && record.openHouseRequested && record.decisions?.openHouse === "Approved";
  const marketingRecovery = record.kind === "listing" && Boolean(
    session.marketingSavedDraft
    || record.decisions?.budget === "Returned"
    || record.marketingRevisionRequired
    || approvedMarketing
  );
  const openHouseRecovery = record.kind === "listing" && Boolean(
    session.openHouseSavedDraft
    || (record.decisions?.openHouse === "Returned" && record.allowOpenHouseEdit)
    || approvedOpenHouse
  );
  const deniedOpenHouse = record.kind === "listing" && record.openHouseRequested && record.decisions?.openHouse === "Denied";

  if (!baseRecovery && !marketingRecovery && !openHouseRecovery && !deniedOpenHouse) return null;

  const marketingTitle = session.marketingSavedDraft
    ? "Marketing Plan Draft"
    : record.marketingRevisionRequired
      ? "Marketing Plan Revision Required"
      : record.decisions?.budget === "Returned"
        ? "Marketing Plan Changes Requested"
        : "Approved Marketing Plan";
  const marketingAction = session.marketingSavedDraft
    ? "Resume Draft"
    : approvedMarketing
      ? "Edit Marketing Plan"
      : "Edit Requested Changes";
  const openHouseTitle = session.openHouseSavedDraft
    ? "Open House Draft"
    : record.decisions?.openHouse === "Returned"
      ? "Open House Changes Requested"
      : "Approved Open House";
  const openHouseAction = session.openHouseSavedDraft
    ? "Resume Draft"
    : approvedOpenHouse
      ? "Edit Open House Request"
      : "Edit Requested Changes";

  return (
    <div className="r2b-home-recovery-wrap">
      <section className="home-dashboard-card home-dashboard-card--wide">
        <h2>Resume Transaction Work</h2>
        <p className="home-card-support">Continue saved, independently returned, or intentionally reopened Release 2B work without reopening unrelated workflow streams.</p>
        <div className="r2b-home-recovery">
          {baseRecovery && (
            <div className="r2b-home-recovery-item">
              <div><strong>{record.status === "Needs Changes" ? "Base Transaction Changes Requested" : "Saved Intake"}</strong><small>{record.status === "Needs Changes" ? record.needsChangesComment || "Leadership requested Base Transaction corrections." : `Resume the saved ${record.kind === "listing" ? "Listing Agreement" : "Pending Transaction"} draft.`}</small></div>
              <button type="button" className="button primary" onClick={() => onResume?.("base")}>Resume</button>
            </div>
          )}
          {marketingRecovery && (
            <div className="r2b-home-recovery-item">
              <div><strong>{marketingTitle}</strong><small>The Base Transaction remains {record.status}. Marketing work is isolated from Base and Open House state.</small></div>
              <button type="button" className="button primary" onClick={() => onResume?.("marketing")}>{marketingAction}</button>
            </div>
          )}
          {openHouseRecovery && (
            <div className="r2b-home-recovery-item">
              <div><strong>{openHouseTitle}</strong><small>The Base Transaction remains {record.status}. The operative Open House request is unchanged until a material edit is resubmitted.</small></div>
              <button type="button" className="button primary" onClick={() => onResume?.("openHouse")}>{openHouseAction}</button>
            </div>
          )}
          {deniedOpenHouse && !openHouseRecovery && (
            <div className="r2b-home-recovery-item">
              <div><strong>Open House Denied</strong><small>The denied version remains historical. A later Open House is a new request, not an edit of the denied request.</small></div>
              <button type="button" className="button primary" onClick={() => onResume?.("openHouseReplacement")}>Create New Open House Request</button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
